import { Children, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface SectionRowsProps {
    children: ReactNode;
    limit?: number;
}

export const SectionRows = ({ children, limit = 8 }: SectionRowsProps) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const rows = Children.toArray(children);
    const shown = expanded ? rows : rows.slice(0, limit);

    return (
        <div className="divide-y divide-subtle">
            {shown}
            {rows.length > limit && (
                <button
                    type="button"
                    onClick={() => setExpanded((prev) => !prev)}
                    className="flex w-full items-center justify-between gap-3 px-4 py-2.5 text-left text-xs font-medium text-subtle-foreground transition-colors hover:bg-muted/50 hover:text-foreground"
                >
                    <span>
                        {expanded
                            ? t('folders.detail.showFewer')
                            : t('folders.detail.showAll', {
                                  count: rows.length,
                              })}
                    </span>
                    {expanded ? (
                        <ChevronUp
                            aria-hidden="true"
                            className="h-3.5 w-3.5 shrink-0"
                        />
                    ) : (
                        <ChevronDown
                            aria-hidden="true"
                            className="h-3.5 w-3.5 shrink-0"
                        />
                    )}
                </button>
            )}
        </div>
    );
};
